import { PricingScheduleCreate, PricingScheduleEdit, PricingScheduleList } from './PricingSchedules'

export default {
  list: PricingScheduleList,
  create: PricingScheduleCreate,
  edit: PricingScheduleEdit,
}
